import { ThemeConfig } from './theme';

const DEFAULT_THEME: ThemeConfig = {
  fontFamilies: {
    primary: 'Plus Jakarta Sans',
    secondary: 'Plus Jakarta Sans',
    fallback: 'Plus Jakarta Sans',
  },
  typography: {
    marquee: {
      'font-family': 'primary',
      'font-size': '24px',
      'font-weight': 600,
      'line-height': '1.3',
      'letter-spacing': '-0.01em',
    },
    header: {
      'font-family': 'primary',
      'font-size': '20px',
      'font-weight': 600,
      'line-height': '1.3',
      'letter-spacing': 0,
    },
    label: {
      'font-family': 'primary',
      'font-size': '16px',
      'font-weight': 600,
      'line-height': '1.2',
      'letter-spacing': 0,
    },
    body: {
      'font-family': 'primary',
      'font-size': '16px',
      'font-weight': 500,
      'line-height': '1.5',
      'letter-spacing': 0,
    },
    caption: {
      'font-family': 'primary',
      'font-size': '12px',
      'font-weight': 500,
      'line-height': '1.5',
      'letter-spacing': '0.01em',
    },
    postscript: {
      'font-family': 'primary',
      'font-size': '10px',
      'font-weight': 500,
      'line-height': '1.5em',
      'letter-spacing': '0.02em',
    },
  },
  colors: {
    'Blue/10': '#E5F0FF',
    'Blue/20': '#CCE0FF',
    'Blue/30': '#A0C6FF',
    'Blue/50': '#1170FF',
    'Blue/70': '#0C4EB3',
    'Blue/80': '#072D66',
    'Blue/90': '#031530',
    'Green/10': '#E5FFED',
    'Green/20': '#CFFCDC',
    'Green/30': '#AAF5BF',
    'Green/50': '#21C44F',
    'Green/70': '#01922A',
    'Green/80': '#0A6123',
    'Green/90': '#00330E',
    'Neutral/0': '#FFFFFF',
    'Neutral/20': '#DBE5F0',
    'Neutral/30': '#C1CFDE',
    'Neutral/50': '#627284',
    'Neutral/70': '#515F6E',
    'Neutral/80': '#474E57',
    'Neutral/90': '#18191B',
    'Neutral/100': '#000000',
    'Purple/10': '#EEE5FF',
    'Purple/20': '#DECCFF',
    'Purple/30': '#BD99FF',
    'Purple/50': '#8B4DFF',
    'Purple/70': '#5E11EE',
    'Purple/80': '#36009E',
    'Purple/90': '#130330',
    'Red/10': '#FFE5E6',
    'Red/20': '#FFCCCC',
    'Red/30': '#FFA0A0',
    'Red/50': '#D23535',
    'Red/70': '#920101',
    'Red/80': '#610A0A',
    'Red/90': '#330000',
    'Teal/10': '#E5FEFF',
    'Teal/20': '#CCFDFF',
    'Teal/30': '#A0FCFF',
    'Teal/50': '#58E9ED',
    'Teal/70': '#12A8AD',
    'Teal/80': '#0A5E61',
    'Teal/90': '#003133',
    'Yellow/10': '#FFF8E5',
    'Yellow/20': '#FFF1CC',
    'Yellow/30': '#FFE4A0',
    'Yellow/50': '#EBAE11',
    'Yellow/70': '#926901',
    'Yellow/80': '#61480A',
    'Yellow/90': '#332500',
  },
  components: {
    background: 'Neutral/0',
    text: {
      default: 'Neutral/90',
      light: 'Neutral/50',
      link: 'Blue/50',
      title: 'Blue/70',
    },
    button: {
      primary: {
        color: 'Blue/50',
        onColor: 'Neutral/0',
      },
      secondary: {
        color: 'Green/50',
        onColor: 'Neutral/0',
      },
      neutral: {
        color: 'Neutral/50',
        onColor: 'Neutral/0',
      },
    },
    input: {
      label: 'Neutral/80',
      error: 'Red/50',
      errorMessage: 'Red/50',
      'border-color': 'Neutral/50',
      background: 'Neutral/0',
      'focus-color': 'Blue/50',
      'icon-color': 'Blue/70',
      'text-color': 'Neutral/70',
      placeholder: 'Neutral/50',
    },
    'circular-frame': {
      'border-color': 'Neutral/70',
      'empty-color': 'Neutral/20',
    },
    card: {
      'border-color': 'Neutral/30',
      'background-color': 'Neutral/0',
      'focus-color': 'Blue/50',
      'disabled-color': 'Neutral/50',
    },
    collapser: {
      'icon-background-on-hover': {
        'background-color': 'Neutral/30',
        opacity: 1,
      },
    },
    loading: {
      color: 'Blue/50',
      'background-color': 'Neutral/20',
    },
    radio: {
      'selected-background': 'Blue/70',
      'icon-border': 'Neutral/30',
      selected: 'Blue/50',
      'icon-background': 'Neutral/0',
    },
    checkbox: {
      'selected-background': 'Blue/70',
      'icon-border': 'Neutral/30',
      selected: 'Blue/70',
      'icon-background': 'Neutral/0',
    },
  },
  animations: {
    duration: {
      short: 250,
      standard: 500,
      long: 1000,
    },
    delay: {
      short: 250,
      standard: 500,
      long: 1000,
    },
    easing: {
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      standard: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      sharp: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
    },
  },
  spacing: 8,
};

export default DEFAULT_THEME;
